import React, {Component} from 'react';
import './Uploader.css';
import {Button,} from 'antd';
import 'react-datetime/css/react-datetime.css'
import Dropzone from "react-dropzone";
import {checkIsPdf, newWindow} from "../../util/Helpers";
import Alert from "react-s-alert";
import EXIF from "exif-js";
import Resizer from 'react-image-file-resizer';


class Uploader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            addToClassName:'',
            thumb:'',
        };
        this.onDrop = this.onDrop.bind(this);
        this.removeItem=this.removeItem.bind(this);
        this.sleepFor=this.sleepFor.bind(this);
        this.setVariable= this.setVariable.bind(this);
    }

    setVariable(variable){
        this.setState(variable);
        console.log(variable);
    }

    getBase64(file, cb) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Base64 Read Error: ', error);
        };
    }

     sleepFor( sleepDuration ){
        var now = new Date().getTime();
        while(new Date().getTime() < now + sleepDuration){ /* do nothing */ }
    }

    onDrop(acceptedFiles, rejectedFiles) {
        var self=this;
        console.log("rejectedFiles==>",rejectedFiles);
        if (rejectedFiles.length > 0) {
            let validity='Yüklenecek Dosyalar 4MB\'dan Büyük Olamaz!'
            Alert.error(
                validity, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 20000
                });
        }
        else {
            self.getBase64(acceptedFiles[0], (result) => {
                this.setState({file_: result});
                this.props.onInfoChange(this.props.fileName, result);
            });
            EXIF.getData(acceptedFiles[0],  function() {
                var orientation = EXIF.getTag(this, "Orientation");
                if ( orientation!==undefined) {
                    if (orientation === 6) {
                        self.setState({addToClassName: ' rotate90'});
                    } else if (orientation === 8) {
                        self.setState({addToClassName: ' rotate270'});
                    } else if (orientation === 3) {
                        self.setState({addToClassName: ' rotate180'});
                    }
                }
            });

            Resizer.imageFileResizer(
                acceptedFiles[0],
                80,
                80,
                'JPEG',
                100,
                0,
                thumb => {
                    self.setState({thumb:thumb});
                },
                'base64'
            );


        }
    }

    removeItem()
    {
        this.props.onInfoChange(this.props.fileName,'');
    }

    render() {
        return (
            <div className="uploader-container row col-sm-12">
                        <Dropzone
                            accept=".jpg,.jpeg,.png,.pdf , image/*, application/pdf"
                            className="dropzone-container col-sm-9 fixed-height"
                            activeClassName="dropzoneActiveClass"
                            disabled={this.props.isDisabled}
                            multiple={false}
                            onDrop={this.onDrop}
                            maxSize={4194304}
                            initialFiles={[ this.props.file]}>
                            {
                                this.props.file === '' || this.props.file === null ?
                                    <div className="dropzone-text">
                                        <img alt="" className="add" src={require('../../icons8-plus-48.png')}/>
                                        <div >Dosya seçmek için tıklayın.</div>
                                    </div>
                                    :
                                    !checkIsPdf(this.props.file)
                                            ?

                                            <div className="dropzone-file">
                                                <img  alt="" className={"thumbnail" +  this.state.addToClassName }  src={this.props.file}/>
                                            </div>
                                            :

                                            <div className="dropzone-file ">
                                                <img alt="" className="thumbnail"   src={require('../../pdf_thumb.png')}/>
                                            </div>
                            }
                        </Dropzone>
                <Button className="remove-button" disabled={this.props.isDisabled} onClick={this.removeItem}/>
                <Button className="preview-button" disabled={this.props.isDisabled} onClick={() =>{this.props.file && newWindow(this.props.file,this.state.addToClassName)}}/>
            </div>
        );
    }
}
export default Uploader;




// WEBPACK FOOTER //
// ./src/components/Uploader/Uploader.js